type SearchCategoryName = { category: string; subCategory?: string };

const getCategoryBySlug = (
  search: TCategorySelection,
  groups: Array<TCategory>
): SearchCategoryName => {
  try {
    const category = groups.find(
      (el: TCategory) => el.slug === search.category
    );
    const fakeCategory = {
      ...category,
      parts: Object.values(category?.parts).reduce(
        (acc, arr) => [...acc, ...arr],
        []
      ),
    };

    const subCategory = search?.subCategory
      ? fakeCategory?.parts.find((el: TPart) => el.slug === search.subCategory)
      : null;

    return {
      category: category?.name || '',
      ...(search?.subCategory && { subCategory: subCategory?.name || '' }),
    };
  } catch (e) {
    return {
      category: '',
      subCategory: '',
    };
  }
};

export default getCategoryBySlug;
